/*

----- PWA ( Progressive Web Application ) functionality ----- 
- When to fire the PWA prompt.
- Storage of installation flag.

*/


var prompt, installEvent, instances = {};

// Sets the installation status. 
function setInstallStatus(value) {
    let status = "";
    switch(value) {
        case true:
            status = "accepted";
            break;
        case false:
            status = "declined";
            break;
        case null:
            status = "not-installed";
            break;
    }
    localStorage.setItem('install-pwa-prompt', status);
    return status;
}
// Checks if the localStorage item has been set. 
function getInstallStatus() {
    return localStorage.getItem('install-pwa-prompt');
}
function getPrompt(context) {
    if (context == undefined) {
        prompt = $('[data-pwa-install-prompt]')
    } else {
        prompt = context;
    }
    return prompt;
}
// Set beforeinstallprompt event.
function setInstallEvent(id, event) {
    return instances[id]['config']['install-event'] = event;
}
// Get beforeinstallprompt event.
function getInstallEvent(id) {
    return instances[id]['config']['install-event'];
}
// Get context.
function setContext(id, context) {
    return instances[id]['config']['context'] = context;
}
// Get instance Id.
function getId(context) {
    return context.data('pwa-id');
}

// Detect whether the PWA has been uninstalled and reconcile localStorage state.
// This runs unconditionally on every page load, it has no DOM dependency.
function detect() {
    // Get the current installation status from localStorage.
    const status = getInstallStatus();
    // If the status is not 'accepted' there is nothing to reconcile.
    if (status !== 'accepted') {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "PWA Detect: No accepted installation status found, skipping detection.");
        }
        return;
    }
    // If running in standalone mode the app is clearly still installed.
    if (isRunningStandalone()) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "PWA Detect: App is running in standalone mode, installation confirmed.");
        }
        return;
    }
    // Status is 'accepted' but not running standalone.
    // Listen for beforeinstallprompt — Chrome will only fire this if the app is NOT installed.
    // If it fires, the user has uninstalled the app.
    window.addEventListener('beforeinstallprompt', function() {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "PWA Detect: beforeinstallprompt fired while status is 'accepted', app has been uninstalled.");
        }
        // Reset the localStorage flag so the install prompt logic can re-engage.
        setInstallStatus(null);
        // Expire the VMerchantApplicationInstall cookie so the server re-sends the notification markup on next navigation.
        // There is no delete method so we have to set the cookie expiry in the past.
        document.cookie = 'VMerchantApplicationInstall=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        // Dispatch a custom event so other modules can react if needed.
        window.dispatchEvent(new CustomEvent('pwa-uninstall-detected'));
    });
}

// Install PWA.
function install(context) {
    let id = getId(context);
    if (id == undefined || !id) {
        AXISDebug.output(3,"PWA: Cannot install App due to PWA instance Id missing");
        return false;
    }
    let installEvent = getInstallEvent(id);
    if (install == undefined || installEvent == null) {
        AXISDebug.output(3,"PWA: Cannot install App due to no install event captured.")
        return false;
    }
    // Prompt final prompt before installation.
    installEvent.prompt();
    
    installEvent.userChoice.then((choice) => {
        // If the user declined, we don't want to show the button again. 
        if (choice['outcome'] !== 'accepted') {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "PWA: Installation declined");
            }
            setInstallStatus(false);
        } else if (choice['outcome'] === 'accepted') {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "PWA: Attempting to install app.");
            }
            setInstallEvent(id, true);
        }
    });
}

// Decline installation.
function decline(context) {
    let id = getId(context);
    if (id == undefined || !id) {
        AXISDebug.output(3,"PWA: Could not decline installation due to no instance Id found.");
        return false;
    }
    // Trash install event.
    setInstallEvent(id, null);
    return setInstallStatus(false);
}
  
function initialise(context) {
    // Create a promise as this is a async request.
    let promise = new Promise(function(resolve, reject) {
        // Generate unique id for instance.
        let id = generateId();
        // Create instance.
        instances[id] = {};
        // Create config.
        instances[id]['config'] = {};
        // Add context.
        setContext(id, context);
        // Add instance Id to the context.
        context.attr(expressSelectors()['axis-pwa']['instance-id'], id);
        // If beforeinstallprompt event fired when ask to install pwa ( this can only be triggered by the browser )
        window.addEventListener('beforeinstallprompt', (event) => {
            // Prevent default behavour.
            event.preventDefault();
            setInstallEvent(id, event);
            // At this point the status is null as the application is not installed.
            const status = setInstallStatus(null);            
            // Used for when the install button is clicked.
            resolve({status: status});
        }, { once: true });

        // App has been installed.
        window.addEventListener('appinstalled', () => {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "PWA: App has been successfully installed");
            }
            // Set status.
            setInstallStatus(true);
        });
    });

    return promise;
}



var AXISPWA = $.AXISPWA = {
    detect: () => {
        return detect();
    },
    initialise: (context) => {
        return initialise(context);
    }, getInstallStatus: () => {
        return getInstallStatus();
    }, install: (context) => {
        return install(context);
    }, decline: (context) => {
        return decline(context);
    }, setPrompt: (context) => {
        return getPrompt(context);
    }
}

export { AXISPWA }